import { createFeatureSelector } from '@ngrx/store';
import { HTTPState } from './feature.state';


export const FEATURE_NAME = 'http-traffic';
export const featureState = createFeatureSelector<HTTPState>(FEATURE_NAME);
